import React, { useState } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import "./Header.css";

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    name: "Krisara Gastro and Liver Clinic",
    url: "https://krisaragastro.com/",
    logo: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    image: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    telephone: "+91 7569541532",
    email: "gastro@krisara.com",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "3rd Floor, Fairmount Square, Pet Basheerabad, Quthbullapur, Kompally",
      addressLocality: "Hyderabad",
      addressRegion: "Telangana",
      postalCode: "500014",
      addressCountry: "IN",
    },
    sameAs: [
      "https://www.facebook.com/krisaragastro",
      "https://www.instagram.com/krisaragastro",
    ],
  };

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const handleLogoClick = () => {
    navigate("/");
    window.scrollTo(0, 0);
    setMenuOpen(false);
  };
  const handleNavClick = () => {
    window.scrollTo(0, 0);
    setMenuOpen(false);
  };
  const isBlogsPage = location.pathname === "/blogs";
  return (
    <header className={`header ${isBlogsPage ? "header-dark" : ""}`}>
      <div className={`header-inner ${isBlogsPage ? "header-inner-dark" : ""}`}>
        {/* Logo */}
        <div className="logo-wrap" onClick={handleLogoClick}>
          <img
            src="https://i.ibb.co/qMM7kKr2/image-2.png"
            alt="Krisara Gastro Logo- Best Gastroenterologist in Kompally Hyderabad - Krisara Gastro Clinic"
            className="logo"
          />
        </div>
        {/* Centered Nav */}
        <nav className="desktop-nav">
          {["/", "/about", "/services", "/blogs", "/doctor"].map((path, i) => {
            const labels = ["Home", "About", "Services", "Blogs", "Doctor"];
            return (
              <NavLink
                key={path}
                to={path}
                className={({ isActive }) =>
                  `nav-link ${isActive ? "active-link" : "inactive-link"}`
                }
                onClick={handleNavClick}
              >
                {labels[i]}
              </NavLink>
            );
          })}
        </nav>
        {/* Right Contact Button */}
        <div className="right-section">
          <a href="tel:7569541532" className="contact-btn desktop-only">
            Contact us ↗
          </a>
          <button
            aria-label="Open Menu"
            className={`menu-toggle ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen((o) => !o)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>
      {/* Mobile Nav */}
      <nav className={`mobile-nav ${menuOpen ? "show" : ""}`}>
        {["/", "/about", "/services", "/blogs", "/doctor"].map((path, i) => {
          const labels = ["Home", "About", "Services", "Blogs", "Doctor"];
          return (
            <NavLink
              key={path}
              to={path}
              className={({ isActive }) =>
                `nav-link ${isActive ? "active-link" : "inactive-link"}`
              }
              onClick={handleNavClick}
            >
              {labels[i]}
            </NavLink>
          );
        })}
        <a
          href="tel:7569541532"
          className="contact-btn mobile-contact"
          onClick={() => setMenuOpen(false)}
        >
          Contact us ↗
        </a>
      </nav>
    </header>
  );
};
export default Header;